 import "es6-promise/auto";

 import {
     setContent
 } from "viewport-extra";

 var ua = navigator.userAgent;
 var isSmartPhone =
     ua.indexOf("iPhone") > -1 || (ua.indexOf("Android") > -1 && ua.indexOf("Mobile") > -1);

 var isTablet = !isSmartPhone &&
     (ua.indexOf("iPad") > -1 ||
         (ua.indexOf("Macintosh") > -1 && "ontouchend" in document) ||
         ua.indexOf("Android") > -1);

 window.addEventListener("DOMContentLoaded", (e) => {
     if (isSmartPhone) {
         setContent({
             minWidth: 375,
         });
     } else if (isTablet) {
         setContent({
             minWidth: 1160,
         });
     }
 });

 import $ from "jquery";
 /**
  * js_common
  *
  */
 import "./common";
 /**
  * js_slick
  *
  */
 //import 'slick-carousel';
 // $(function () {
 //     var $jsSlick = $('.js_slick');
 //     if ($jsSlick[0]) {
 //         $('.js_slick').slick({
 //             autoplay: true,
 //             autoplaySpeed: 5000,
 //             slidesToShow: 1,
 //             slidesToScroll: 1,
 //             dots: true,
 //             arrow: true,
 //             prevArrow: '<img src="/_html/_assets/img/icon/icn_arrow__left.png" class="slide-arrow prev-arrow">',
 //             nextArrow: '<img src="/_html/_assets/img/icon/icn_arrow__left.png" class="slide-arrow next-arrow">',
 //             responsive: [{
 //                 breakpoint: 750,
 //                 settings: {
 //                     //            edge: true,
 //                 }
 //     }]
 //         });
 //     }
 // });

 /**
  * js_slick
  *
  */
 import 'slick-carousel';
 $(function () {
     var $jsSlick__mvTop = $('.js_slick__mvTop');
     if ($jsSlick__mvTop[0]) {
         $jsSlick__mvTop.slick({
             autoplay: true,
             autoplaySpeed: 5000,
             slidesToShow: 1,
             slidesToScroll: 1,
             dots: true,
             arrows: false,
             //             arrow: true,
             //             prevArrow: '<img src="/_html/_assets/images/icons/icn_arrow__left.png" class="slide-arrow prev-arrow">',
             //             nextArrow: '<img src="/_html/_assets/images/icons/icn_arrow__right.png" class="slide-arrow next-arrow">',
             fade: true,
             speed: 1000,
             responsive: [{
                 breakpoint: 768,
                 settings: {
                     //            edge: true,
                 }
     }]
         });
     }
 });




 // import Swiper from 'swiper'; 最小限の機能しか入っていない
 import Swiper from 'swiper/bundle'; // 全ての機能が入っている

 //const option = {
 //  loop: true,
 //  autoplay: true,
 //}
 //
 //const swiper = new Swiper('.mySwiper', option);


 //const swiper = new Swiper('.swiper', {
 //  // Optional parameters
 //  direction: 'vertical',
 //  loop: true,
 //
 //  // If we need pagination
 //  pagination: {
 //    el: '.swiper-pagination',
 //  },
 //
 //  // Navigation arrows
 //  navigation: {
 //    nextEl: '.swiper-button-next',
 //    prevEl: '.swiper-button-prev',
 //  },
 //
 //  // And if we need scrollbar
 //  scrollbar: {
 //    el: '.swiper-scrollbar',
 //  },
 //});



 window.addEventListener('DOMContentLoaded', function () {
     var menu = ['01', '02', '03'];
     var swiper = new Swiper(".mySwiper", {
         effect: "cards",
         loop: true,
         //     slideShadows: false,
         transformEl: {
             translate3d: '300px',
         },
         //        grabCursor: true,
         loop: false,
         navigation: {
             nextEl: '.swiper-button-next',
             prevEl: '.swiper-button-prev',
         },
         //      pagination: {
         //      el: '.swiper-pagination',
         //    },
         pagination: {
             el: '.swiper-pagination.pagination-bottom, .swiper-pagination.pagination-top',
             clickable: true,
             renderBullet: function (index, className) {
                 return '<span class="' + className + '">' + (menu[index]) + '</span>';
             },
         },
     });
 }, false);


 //let mySwiper = new Swiper ('.mySwiper2', {
 //  // 以下にオプションを設定
 //  loop: true, //最後に達したら先頭に戻る
 //
 //  //ページネーション表示の設定
 //  pagination: {
 //    el: '.swiper-pagination', //ページネーションの要素
 //    type: 'bullets', //ページネーションの種類
 //    clickable: true, //クリックに反応させる
 //  },
 //
 //  //ナビゲーションボタン（矢印）表示の設定
 //  navigation: {
 //    nextEl: '.swiper-button-next', //「次へボタン」要素の指定
 //    prevEl: '.swiper-button-prev', //「前へボタン」要素の指定
 //  },
 //
 //  //スクロールバー表示の設定
 //  scrollbar: {
 //    el: '.swiper-scrollbar', //要素の指定
 //  },
 //});
 let mySwiper = new Swiper('.mySwiper2', {
     loop: true,
     slidesPerView: 3,
     speed: 1000,
     //  centeredSlides : true,
     //     effect: 'coverflow',
     //     coverflowEffect: {
     //         rotate: 0,
     //         stretch: 0,
     //         depth: 300,
     //         modifier: 0,
     //         slideShadows: false
     //     },


     //          spaceBetween: -10,

     pagination: { //ページネーションを表示
         el: '.swiper-pagination',
         clickable: true, //アイコンをクリックすると対応するスライドに移動
     },

     navigation: { //ナビゲーションボタンを表示
         nextEl: '.swiper-button-next',
         prevEl: '.swiper-button-prev',
     },
 });



 // $(document).on("click", '.swiper-button-next', function () {
 //     $(this).parents('.bl_test_swiper').find('.swiper-slide').css({
 //         'opacity': '0.9'
 //     });
 //
 //     //     setTimeout(function () {
 //     //       $(this).parents('.bl_test_swiper').find('.swiper-slide').attr({'opacity': ''});
 //     //     }, 300);
 //
 //     setTimeout($.proxy(function () {
 //         $(this).parents('.bl_test_swiper').find('.swiper-slide').animate({
 //             'opacity': '1'
 //         }, 300, 'swing');
 //         console.log("aaa");
 //     }, this), 200);
 //
 //
 //
 // });

 /**
  * js_objectFitImages
  *
  */
 import objectFitImages from "object-fit-images";
 if ($(".js_ofiImg")[0]) {
     objectFitImages(".js_ofiImg");
 }

 /**
  * js_bodyScrollLock
  *
  */
 //import {
 //    disableBodyScroll,
 //    enableBodyScroll,
 //    clearAllBodyScrollLocks
 //} from 'body-scroll-lock';
 /**
  * js_modal
  *
  */
 import "./_lib/modal";
 /**
  * js_popup
  *
  */
 // import "magnific-popup";
 // $(function () {
 //     if ($('.js_popUp_iframe')[0] && $(window).width() < 751) {
 //         $(".js_popUp_iframe").on("click", function (e) {
 //             e.preventDefault();
 //             $("body").css({
 //                 overflow: "hidden",
 //             });
 //             no_scroll();
 //         });
 //     }
 // });
 // $(function () {
 //     if ($('.js_popUp_iframe')[0] && $(window).width() < 751) {
 //         $(document).on('click', '.mfp-close , .mfp-wrap , .mfp-bg', function () {
 //             $("body").css({
 //                 overflow: "auto",
 //             });
 //             return_scroll();
 //         });
 //     }
 // });
 // $(function () {
 //     if ($('.js_popUp_iframe')[0]) {
 //         $('.js_popUp_iframe').magnificPopup({
 //             type: 'iframe',
 //             mainClass: 'mfp-fade',
 //             removalDelay: 200,
 //             preloader: false,
 //         });
 //     }
 // });
 /**
  * js_matchHeight
  *
  */
 // import MatchHeight from 'matchheight';
 // $(function () {
 //     if ($('.ly_sample')[0]) {
 //         $('.jsMatchHeight.bl_sample').matchHeight();
 //         $('.jsMatchHeight.bl_sample').matchHeight();
 //         if ($(window).width() > 751) {
 //             $('.jsMatchHeight.bl_sample').matchHeight();
 //         }
 //     }
 //
 //     $(window).on('resize', function () {
 //         if ($('.ly_sample')[0]) {
 //             $('.jsMatchHeight.bl_sample').matchHeight();
 //             $('.jsMatchHeight.bl_sample').matchHeight();
 //             if ($(window).width() > 751) {
 //                 $('.jsMatchHeight.bl_sample').matchHeight();
 //             }
 //         }
 //     });
 // });


 /**
  * js_loading
  *
  */
 // import "./_lib/jquery.cookie";
 //     //同じ日付で2回目以降ならローディング画面非表示の設定
 //     var splash_text = $.cookie('accessdate'); //キーが入っていれば年月日を取得
 //     var myD = new Date(); //日付データを取得
 //     var myYear = String(myD.getFullYear()); //年
 //     var myMonth = String(myD.getMonth() + 1); //月
 //     var myDate = String(myD.getDate()); //日
 //
 //     if (splash_text != myYear + myMonth + myDate) { //cookieデータとアクセスした日付を比較↓
 //
 //         if ($("#splash")[0]) {
 //             $("#splash").css("display", "block"); //１回目はローディングを表示
 //             setTimeout(function () {
 //                 $("#splash_logo").fadeIn(1000, function () { //1000ミリ秒（1秒）かけてロゴがフェードイン
 //                     setTimeout(function () {
 //                         $("#splash_logo").fadeOut(1000); //1000ミリ秒（1秒）かけてロゴがフェードアウト
 //                     }, 1000); //1000ミリ秒（1秒）後に処理を実行
 //                     setTimeout(function () {
 //                         $("#splash").fadeOut(1000, function () { //1000ミリ秒（1秒）かけて画面がフェードアウト
 //                             var myD = new Date();
 //                             var myYear = String(myD.getFullYear());
 //                             var myMonth = String(myD.getMonth() + 1);
 //                             var myDate = String(myD.getDate());
 //                             $.cookie('accessdate', myYear + myMonth + myDate); //accessdateキーで年月日を記録
 //                         });
 //                     }, 1700); //1700ミリ秒（1.7秒）後に処理を実行
 //                 });
 //             }, 1000); //1000ミリ秒（1秒）後に処理を実行
 //         } else {
 //             $("#splash").css("display", "none"); //同日2回目のアクセスでローディング画面非表示
 //         }
 //     }

 /**
  * js_form
  *
  */
 import "./_lib/jquery.validate.min.js";
 import "./_lib/additional-methods.min.js";
 import "./_lib/jquery.jpostal.js";
 import "./_lib/form.js";

 /**
  * js_lazysizes
  *
  */
 import "./_lib/lazysizes.js";



 // import gsap from "gsap";
 //
 // document.querySelectorAll('.box').forEach(function (item) {
 //     item.addEventListener("click", function () {
 //         sample(item);
 //     });
 // });
 //
 // var sample = function (aaa) {
 //     gsap.to(aaa, {
 //         width: '80%',
 //         height: '100px',
 //         scale: 3,
 //         ease: "back.inOut", // イージング
 //         duration: 2.5, // アニメーションの時間
 ////          paused: true, // 勝手にアニメーションが始まらないように
 //         backgroundColor: '#f0f',
 //     });
 // }

 // import {
 //	gsap
 //} from "gsap";
 //import {
 //	ScrollToPlugin
 //} from "gsap/ScrollToPlugin";
 //import {
 //	ScrollTrigger
 //} from "gsap/ScrollTrigger";
 //
 //gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
 //
 //import {
 //	disableBodyScroll,
 //	enableBodyScroll,
 //	clearAllBodyScrollLocks
 //} from 'body-scroll-lock';
 //
 // var dbody = document.body
 //
 //var drawer_overlay = document.createElement('div');
 //var sp_drawer_menu = document.getElementById('sp-drawer-menu');
 //
 //drawer_overlay.classList.add('l-drawer-overlay');
 // var fade_duration = 200;




